import { Box, Typography } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

const Unauthorized = () => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
      minHeight: "60vh",
      textAlign: "center",
      color: "text.secondary",
      gap: 1.5,
    }}
  >
    <LockOutlinedIcon sx={{ fontSize: 48 }} />
    <Typography variant="h6">You don&apos;t have permission to view this page</Typography>
    <Typography variant="body2">
      Contact your administrator if you think this is a mistake.
    </Typography>
  </Box>
);

export default Unauthorized;
